import styled from 'styled-components';

import { IHeader } from './Header';

export const Container = styled.div<IHeader.IRowContent>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  background-color: ${({ theme }) => theme.colors.gray950};
  filter: ${({ hasChildren }) => hasChildren && 'drop-shadow(0px 6px 12px rgba(0, 0, 0, 0.24))'};
  position: fixed;
  left: 0;
  right: 0;
  z-index: 3;
`;

export const RowContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 60px;
  padding: 0 24px;
`;

export const Title = styled.label`
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 24px;
  text-align: center;
  color: ${({ theme }) => theme.colors.gray0};
  padding: 20px 0;
  text-transform: capitalize;
`;

export const BackButton = styled.button`
  width: 24px;
  height: 24px;
  background-color: transparent;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  transform: rotate(90deg);
`;

export const EmptyBox = styled.div`
  width: 24px;
  height: 24px;
`;

export const ChildContent = styled.div`
  display: flex;
  justify-content: center;
`;
